import { useContext } from "react";
import { t } from "i18next";
import { AuthContext } from "../context/AuthContext";
import { getSMSCategoryName } from "../constants_map";

export function useIsAuthConfigEnabled() {
  const { globalConfigMap } = useContext(AuthContext);
  return globalConfigMap.isEnabled("enableAuthConfig", false);
}

// "OTP" category is shown as "Authentication" when authconfig is enabled.
export default function useOtpLabel() {
  return useIsAuthConfigEnabled() ? "Authentication" : "OTP";
}

// Maps a category/feature name coming from the API: only "OTP" is renamed.
export function useCategoryLabel() {
  const otpLabel = useOtpLabel();
  return (name) => (name?.toUpperCase() === "OTP" ? otpLabel : name);
}

// Translated label for an SMS/RCS template category code (0|1|2).
export function useSMSCategoryLabel() {
  const otpLabel = useOtpLabel();
  return (category) => {
    const key = getSMSCategoryName(category);
    return key === "OTP" ? otpLabel : t(key);
  };
}
